<div class="integration-config">
  <div class="title">
    <div class="back" (click)="goBack()">
      <img src="assets/icons/chevron-left-white.svg" alt="chevron-left" />
      <p>QR físico</p>
    </div>
  </div>
  <p class="text">
    La forma de aceptar criptomonedas en tu local a través de un código QR. Solo tenés que imprimir
    y mostrar el QR en tu local para que tus clientes puedan pagar desde sus wallet. Las
    credenciales para poder comenzar se envían a tu mail.
  </p>
  <div class="qr-actions">
    <div class="action-btn">
      <img src="assets/images/book.svg" alt="" />
      <p>Manual de integración</p>
      <a
        href="https://tiendacrypto.notion.site/Integraci-n-del-QR-F-sico-de-TiendaCrypto-3700cf852d2f43698416411926353295"
        target="_blank"
        rel="noopener noreferrer"
      ></a>
    </div>
    <div class="action-btn pointer" (click)="openRequestQrDialog()">
      <img src="assets/images/integrations/qr.svg" alt="" />
      <p>Solicitar cartón QR</p>
    </div>
    <div class="action-btn">
      <img src="assets/icons/commerce/commerce-icon.svg" alt="" />
      <p>Ir a posnet</p>
      <a [href]="commerceCheckoutUrl" target="_blank" rel="noopener noreferrer"></a>
    </div>
    <div class="action-btn pointer" (click)="openChangePasswordDialog()">
      <img src="assets/icons/user-white.svg" alt="" />
      <p>Cambiar contraseña</p>
    </div>
  </div>
</div>
